import apiClient from "../apiClient";
import { AUTH_ENDPOINTS } from "../endpoints/auth";

export const sendAuthLogin = async (payload) => {
  try {
    const response = await apiClient.post(AUTH_ENDPOINTS.login, payload);
    return response.data;
  } catch (error) {
    console.error("Error sending auth login:", error);
    throw error;
  }
};

export const verifyAuthOtp = async (payload) => {
  try {
    const response = await apiClient.post(AUTH_ENDPOINTS.verifyOtp, payload);
    return response.data;
  } catch (error) {
    console.error("Error verifying auth OTP:", error);
    throw error;
  }
};

export const getUserDetails = async (token) => {
  try {
    const response = await apiClient.post(AUTH_ENDPOINTS.getUserDetails, {
      token,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};

export const updateUser = async (payload) => {
  try {
    const response = await apiClient.post(AUTH_ENDPOINTS.updateUser, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const deleteAccount = async ({ token, reason }) => {
  try {
    const response = await apiClient.post(AUTH_ENDPOINTS.deleteAccount, {
      token,
      reason,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting account:", error);
    throw error;
  }
};
